import {
  Component,
  EventEmitter,
  inject,
  Injectable,
  OnDestroy,
  Type,
} from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private readonly router: Router = inject(Router);

  displayed: boolean;
  contentComponent: Type<Component>;
  dialogComponent: Component;
  className: string;
  title?: string;
  onModalRendered: EventEmitter<Component> = new EventEmitter<Component>();
  onModalClose: EventEmitter<never> = new EventEmitter<never>();

  constructor() {
    this.router.events.subscribe(() => {
      // Close popup on route change
      if (this.displayed) {
        this.hide();
      }
    });
  }

  display(className?: string): void {
    this.reset();
    this.setClassName(className);
    this.displayed = true;
  }

  hide(): void {
    this.displayed = false;
  }

  close(): void {
    this.onModalClose.emit();
  }

  reset(): void {
    this.dialogComponent = undefined;
    this.className = undefined;
    this.contentComponent = undefined;
    this.title = undefined;
  }

  setClassName(className: string): void {
    this.className = className;
  }

  setTitle(title: string): void {
    this.title = title;
  }

  setDialogComponent(
    ComponentClass: Type<any>,
    forceComponentRebuild = false
  ): void {
    if (!forceComponentRebuild && ComponentClass === this.contentComponent) {
      return;
    }
    this.contentComponent = ComponentClass;
  }

  setBuildedDialogComponent(component: Component): void {
    this.dialogComponent = component;
    this.onModalRendered.emit(component);
  }
}
